import React from 'react';
import { Menu, Dropdown, Button, Avatar } from 'antd';
import { SwapOutlined, LogoutOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import { useTheme } from '../App'; // Import the theme hook from App.js

const UserDropdown = ({ memberName, currentOrg, onSwitchOrg, onLogout }) => {
  const { theme } = useTheme();

  const menu = (
    <Menu
      style={{
        backgroundColor: theme.surfaceLight,
        border: `1px solid ${theme.border}`,
        borderRadius: '8px',
        padding: '4px',
      }}
    >
      <Menu.Item 
        key="current-org" 
        disabled 
        style={{ 
          cursor: 'default', 
          fontWeight: 'bold',
          color: theme.text,
          backgroundColor: theme.surface,
          borderRadius: '6px',
          marginBottom: '4px',
        }}
      >
        {currentOrg ? `📁 ${currentOrg.name}` : 'No Organization Selected'}
      </Menu.Item>
      
      <Menu.Divider style={{ backgroundColor: theme.border, margin: '4px 0' }} />
      
      <Menu.Item 
        key="switch-org" 
        onClick={onSwitchOrg}
        style={{
          color: theme.text,
          borderRadius: '6px',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.domEvent.currentTarget.style.backgroundColor = theme.surface;
          e.domEvent.currentTarget.style.color = theme.primary;
        }}
        onMouseLeave={(e) => {
          e.domEvent.currentTarget.style.backgroundColor = 'transparent';
          e.domEvent.currentTarget.style.color = theme.text;
        }}
      >
        <SwapOutlined style={{ marginRight: 8 }} />
        Switch Organization
      </Menu.Item>
      
      <Menu.Item 
        key="logout" 
        onClick={onLogout}
        style={{
          color: theme.text,
          borderRadius: '6px',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.domEvent.currentTarget.style.backgroundColor = `${theme.error}20`;
          e.domEvent.currentTarget.style.color = theme.error;
        }}
        onMouseLeave={(e) => {
          e.domEvent.currentTarget.style.backgroundColor = 'transparent';
          e.domEvent.currentTarget.style.color = theme.text;
        }}
      >
        <LogoutOutlined style={{ marginRight: 8 }} />
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button 
        type="text" 
        style={{ 
          color: theme.text,
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '4px 12px',
          borderRadius: '20px',
          transition: 'all 0.2s ease',
          border: `1px solid ${theme.border}`,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = theme.surfaceLight;
          e.currentTarget.style.borderColor = theme.primary;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
          e.currentTarget.style.borderColor = theme.border;
        }}
      >
        <Avatar 
          size="small" 
          style={{ 
            backgroundColor: theme.primary,
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        >
          {memberName.charAt(0).toUpperCase()}
        </Avatar>
        <span style={{ fontSize: '14px' }}>{memberName}</span>
        <DownOutlined style={{ fontSize: '12px' }} />
      </Button>
    </Dropdown>
  );
};

export default UserDropdown;